<mat-form-field>
  <input
    matInput
    readonly
    (paste)="onPaste($event)"
    placeholder="Paste Excel Here"
  />
</mat-form-field>